/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./LoginPrompt.css";
import { Link } from "react-router-dom";
import { simpleFetch } from "../../restWrapper";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { getOrganizationID, validatePlatformMatch } from "../../assets/helper";
import { PLATFORM } from "../../config";
import checkplusLogo from "../../assets/component/images/checkplus-v-logo.svg";
import plugLogoWhite from "../../assets/component/images/plug-logo-white.svg";

class LoginPrompt extends Component {
  constructor(props) {
    super(props);
    const subdomain = getOrganizationID(window.location.href).subdomain;
    const domain = getOrganizationID(window.location.href).domain;
    const isCustomDomain = getOrganizationID(window.location.href).isCustomDomain;
    this.state = {
      fetching: true,
      // To avoid inital fetching & InfiniteScroll fetching
      // At the same time
      subdomain: subdomain,
      domain: domain,
      isCustomDomain: isCustomDomain,
    };
  }

  componentDidMount() {
    if (this.state.subdomain === null || this.state.subdomain === "") {
      return false;
    }
    if (this.state.subdomain === "www") {
      return false;
    }

    simpleFetch("/donors/organization", "GET", {
      subDomain: this.state.isCustomDomain ? this.state.domain : this.state.subdomain,
      isCustomDomain: this.state.isCustomDomain,
    }).then((res) => {
      if (res.status !== 200) {
        this.props.history.push({ pathname: "/" + this.props.language });
        return false;
      }

      // Validate platform matches organization type
      const platformMatch = validatePlatformMatch(
        res.body.organizationObj.organizationType,
        PLATFORM
      );

      if (!platformMatch) {
        // console.error("Cannot display login page: platform mismatch");
        this.props.history.push({ pathname: "/" + this.props.language });
        return false;
      }

      this.setState({
        ...this.state,
        ...{
          fetching: false,
          headerColor: res.body.organizationObj.headerColor,
          buttonColor: res.body.organizationObj.buttonColor,
          progressBarColor: res.body.organizationObj.progressBarColor,
          logo: res.body.organizationObj.logo,
          organizationName: res.body.organizationObj.organizationName,
        },
      });
    });
  }
  render() {
    if (this.state.fetching) {
      return (
        <div className="SelectMission-emptyPage">
          <div className="SelectMission-center">
            <div className="SelectMission-btm-load"></div>
          </div>
        </div>
      );
    }

    const languageObj = this.props.languageObj;

    const logoStyle = this.state.logo
      ? {
        backgroundImage: "url('" + this.state.logo + "')",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        border: "none",
      }
      : null;

    const backgroundOverrideStyle = {
      background: "#" + this.state.headerColor,
    };

    const organizationName = this.state.organizationName;

    /*
    const buttonOverrideStyle = {
      background: '#' + this.state.headerColor,
      color: '#' + this.state.buttonColor
    };
*/
    return (
      <div className="LoginPrompt-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="LoginPrompt-prompt">
          <div
            className="LoginPrompt-backLink"
            onClick={() =>
              window.history.length > 1
                ? this.props.history.goBack()
                : this.props.history.push("/SelectMission")
            }
          >
            <div className="LoginPrompt-backContainer">
              <div className="LoginPrompt-back">
                <div className="LoginPrompt-backBtn" />
                <div className="LoginPrompt-backText">
                  {languageObj.backTxt}
                </div>
              </div>
            </div>
          </div>

          <Link
            to={{
              pathname: "/LoginEmail",
              state: {
                logoStyle: logoStyle,
                organizationName: organizationName,
                color: {
                  headerColor: this.state.headerColor,
                  buttonColor: this.state.buttonColor,
                },
              },
            }}
          >
            <div className="LoginPrompt-signupContainer">
              <div className="LoginPrompt-signupText">
                {languageObj.signupBtn}
              </div>
            </div>
          </Link>

          <div
            className="LoginPrompt-logoContainer"
            style={backgroundOverrideStyle}
          >
            {logoStyle && (
              <div className="LoginPrompt-logo" style={logoStyle}></div>
            )}
          </div>

          <div className="LoginPrompt-text">{languageObj.text}</div>

          <Link
            to={{
              pathname: "/LoginEmail",
              state: {
                logoStyle: logoStyle,
                organizationName: organizationName,
                color: {
                  headerColor: this.state.headerColor,
                  buttonColor: this.state.buttonColor,
                },
              },
            }}
          >
            <div className="LoginPrompt-loginBtn" data-testid="loginprompt-login-btn">
              <img
                src={PLATFORM === "plug" ? plugLogoWhite : checkplusLogo}
                alt={PLATFORM === "plug" ? "Plug" : "CheckPlus"}
                className="LoginPrompt-checkplusLogo"
                style={PLATFORM === "plug" ? { width: "22px" } : undefined}
              />
              <div className="LoginPrompt-loginText">
                {languageObj.loginTxt?.replace("CheckPlus", PLATFORM === "plug" ? "Plug" : "CheckPlus")}
              </div>
            </div>
          </Link>

          <Link to="/LoginFaq">
            <div className="LoginPrompt-privacyContainer">
              <div className="LoginPrompt-privacyIcn" />
              <div className="LoginPrompt-privacyTxt">
                {languageObj.privacy?.replace("CheckPlus", PLATFORM === "plug" ? "Plug" : "CheckPlus")}
              </div>
            </div>
          </Link>

          <div className="LoginPrompt-footerNav">
            <a
              href="https://check.plus/EnPrivacyPolicy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="LoginPrompt-footerNavItem">
                {languageObj.privacyPolicy}
              </div>
            </a>

            <a
              href="https://check.plus/EnTerms"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="LoginPrompt-footerNavItem">
                {languageObj.terms}
              </div>
            </a>
          </div>

          <div className="LoginPrompt-chin" />
        </div>
      </div>
    );
  }
}

LoginPrompt.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default LoginPrompt;
